import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

/**
 * 审核管道
 *  @example <td [innerHTML]="data.state | auditState"></td>
 */
@Pipe({
  name: 'auditState'
})
export class AuditStatePipe implements PipeTransform {


  //获取当前dom节点
  constructor(
    private dom: DomSanitizer,
    private translate: TranslateService) { }

  /**
   * 管道的初始化方法
   * 
   * 0：<span style="cursor:pointer"  class="state-error">未提交</span>
   * 
   * 1：<span style="cursor:pointer"  class="state-info">审核中</span>
   * 
   * 2：<span style="cursor:pointer"  class="state-success">已通过</span>
   * 
   * 3：<span style="cursor:pointer"  class="state-waring">已驳回</span>
   * 
   * 4:<span style="cursor:pointer"  class="state-error">退回重审</span>
   * 
   * 5:<span style="cursor:pointer"  class="state-error">已撤销</span>
   */
  transform(value: number | string): any {
    if(value || value == 0 || value == '0'){
      value = parseInt(value.toString())
      switch (value){
        case 0:  return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-error">${this.translate.instant("fam.aps.commonWords.unsubmitted")}</span>`); 
        case 1: 
        case 9:
           return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-info">${this.translate.instant("fam.aps.commonWords.review")}</span>`); 
        case 2:  return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-success">${this.translate.instant("fam.aps.commonWords.passed")}</span>`);
        case 3:  return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-waring">${this.translate.instant("fam.aps.commonWords.Returned")}</span>`);
        case 4:  return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-error">${this.translate.instant("fam.aps.commonWords.rejected")}</span>`); 
        case 5:  return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-error">${this.translate.instant("fam.aps.commonWords.Revoked")}</span>`);   }
      }
    }
}
